<template>
  <div class="cardTicket-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <div>
          <el-form-item label="卡券内容：" prop="ticketName">
            <el-input v-model="form.ticketName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="拥有账户：" class="phone" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
          <el-button type="primary" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="ticketName"
          label="卡券内容"
          align="center"
        ></el-table-column>
        <el-table-column label="卡券日期" align="center">
          <template slot-scope="scope"
            >{{ scope.row.ticketBeginTime }}-{{
              scope.row.ticketEndTime
            }}</template
          >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="拥有账户"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="生成时间"
          align="center"
        ></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.ticketState === 1">未使用</span>
            <span v-else-if="scope.row.ticketState === 2">已使用</span>
            <span v-else>已过期</span>
          </template>
        </el-table-column>
        <el-table-column prop="finishTime" label="使用时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.finishTime ? scope.row.finishTime : '-' }}
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { getMyTicketList, excelPort } from '@/api/cardTicket';
import Pagination from '@/components/Pagination';
import Excel from '@/mixins/export';

export default {
  mixins: [Excel],
  data() {
    return {
      dialogVisible: false,
      form: {
        ticketName: '',
        userName: '',
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getMyTicketList();
  },
  methods: {
    getMyTicketList() {
      this.loading = true;
      getMyTicketList({
        ...this.form,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getMyTicketList();
    },
    // 导出
    handleExport() {
      excelPort(this.form).then((res) => {
        this.exportExcel(res, '兑换券列表');
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getMyTicketList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getMyTicketList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getMyTicketList();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.view
  color #1890ff
  cursor pointer
.storeImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
.phone
  margin-left 30px
>>>textarea
  min-height 90px !important
.operate
  width 240px
  flex-row-nowrap()
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
